import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@/features/auth-store.service';
import { resolveHomeUrl } from '@/routes/resolve-home-url';

export const guestGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (!authStore.isAuthenticated()) {
    return true;
  }

  const homeUrl = resolveHomeUrl();
  if (homeUrl === undefined) {
    authStore.logout();
    return true;
  }

  return router.createUrlTree([homeUrl]);
};
